import React from 'react';

type Props = {
  Component: string;
  className?: string;
  children?: React.ReactNode[] | null;
};
/**
 * A wrapper component whose function is to pass the class name generated by
 * the emotion's babel plugin down to it's (only) child.
 *
 * @returns A custom component with a `class` prop applied.
 */
const Wrapper: React.FC<Props> = ({ Component, children, className, ...props }) => {
  const CustomComponent = Component as unknown as React.ComponentType<{
    /**
     * TS seems to think that when you have a string as a component, it cannot
     * have children or props.
     */
    class?: string;

    children?: React.ReactNode[] | null;
  }>;

  return (
    <CustomComponent {...props} class={className}>
      {children}
    </CustomComponent>
  );
};

export default Wrapper;
